import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsTeamsPerPage,
  type IResponseTeamPayload,
  type IResponseTeamsPerPage,
} from './types'

class Api {
  getTeamsPerPage(
    params: IParamsTeamsPerPage,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseTeamsPerPage>> {
    return baseApi.get('groups', { ...options, params })
  }

  deleteTeam(id: number, options?: AxiosOptions): Promise<AxiosResponse<void>> {
    return baseApi.delete(`groups/${id}`, { ...options })
  }

  getTeam(id: number, options?: AxiosOptions): Promise<AxiosResponse<IResponseTeamPayload>> {
    return baseApi.get(`groups/${id}`, options)
  }
}

export const TeamsApi = new Api()
